import enhancedFormWizard from './enhancedFormWizard';

export default enhancedFormWizard;
